import { InvestorCustomTagCategory } from '.';

export interface Address {
  address1: string;
  address2?: string;
  city: string;
  postcode: string;
  country: string;
  isApplyAddress?: boolean;
}

export enum SignUpSource {
  CloneFromExistingInvestor = 'cloneFromExistingInvestor',
  Upload = 'upload',
  AddSingleInvestor = 'addSingleInvestor',
  Adviser = 'adviser',
  SelfSignup = 'selfSignup',
}

export type InvestorCustomTag = {
  tag: string;
  category: InvestorCustomTagCategory;
};
